export default function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section
      data-testid="page-header"
      className="relative pt-40 pb-24 overflow-hidden"
    >
      {image && (
        <div className="absolute inset-0 z-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/85 to-[#050505]" />
        </div>
      )}
      <div className="relative z-10 container mx-auto px-6 md:px-12">
        {overline && <p className="overline mb-5">{overline}</p>}
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[1.02] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-white/65 text-lg leading-relaxed max-w-2xl">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
